import React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";
import "./icon.scss";

const getStyle = props => {
  if (props.width && props.height) {
    return {
      width: props.width,
      height: props.height
    };
  }
  return null;
};

const Icon = props => {
  const {
    src,
    dataTestId,
    width,
    height,
    size,
    actionable,
    clickable,
    muted,
    inactive,
    classes,
    onClick,
    svg
  } = props;

  if (src) {
    return (
      <img
        data-testid={dataTestId}
        draggable={false}
        src={src}
        className={gatherClasses(
          props,
          "oui-dr-icon",
          "oui-svg-icon",
          !(width && height) ? `oui-${size}` : null,
          actionable ? "oui-actionable" : null,
          clickable ? "oui-clickable" : null,
          muted ? "oui-muted" : null,
          inactive ? "oui-inactive" : null
        )}
        style={getStyle(props)}
        alt="svg-icon"
        onClick={props.onClick}
        aria-hidden="true"
      />
    );
  }

  if (classes) {
    return (
      <i
        data-testid={dataTestId}
        className={gatherClasses(
          props,
          "oui-dr-icon",
          "oui-font-icon",
          classes,
          actionable ? "oui-actionable" : null,
          clickable || actionable ? "oui-clickable" : null,
          muted ? "oui-muted" : null,
          inactive ? "oui-inactive" : null
        )}
        aria-hidden="true"
        onClick={onClick}
      />
    );
  }

  if (svg) {
    return svg;
  }

  return null;
};

Icon.defaultProps = {
  size: "sm",
  actionable: false,
  clickable: false,
  inactive: false,
  muted: true,
  dataTestId: "orion-icon"
};

Icon.displayName = "OrionIcon";

Icon.propTypes = {
  src: PropTypes.string,
  svg: PropTypes.node,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  width: PropTypes.string,
  height: PropTypes.string,
  classes: PropTypes.string,
  onClick: PropTypes.func,
  actionable: PropTypes.bool,
  clickable: PropTypes.bool,
  muted: PropTypes.bool,
  inactive: PropTypes.bool,
  dataTestId: PropTypes.string
};

export default Icon;
